module.exports = __webpack_public_path__ + "img/smart10.47ddc5b8.png";